import React, { useEffect, useState, createElement } from 'react';
const CART_URL = 'https://carlosponte.com/cart/add?id=56937498575173&quantity=1';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else if (window.scrollY < 200) {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 z-50 bg-white border-t-[3px] border-brand-yellow py-3.5 px-6 flex flex-col md:flex-row items-center justify-between gap-4 transition-transform duration-300 shadow-lg ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-151">
      <p className="font-display font-extrabold text-brand-ink uppercase tracking-wide text-sm md:text-base text-center md:text-left" data-id="element-152">
        40 Herramientas Clínicas TEA ·{' '}
        <span className="text-brand-yellow-dark" data-id="element-153">Solo $17.999</span> — Oferta
        cierra hoy
      </p>
      <a href="https://tododigitalizado.site/checkouts/cn/hWNAFDMBJq2tSDau5BqP6GNG/es-ar?_r=AQABYsDDvKaVTPqGnQqAJ2wodVAATcC181_JPzytgbqUyF0&preview_theme_id=133867339873" onClick={e => {
      e.preventDefault();
      const checkoutUrl = 'https://tododigitalizado.site/checkouts/cn/hWNAFDMBJq2tSDau5BqP6GNG/es-ar?_r=AQABYsDDvKaVTPqGnQqAJ2wodVAATcC181_JPzytgbqUyF0&preview_theme_id=133867339873';
      // Inicializar Pixel si aún no está cargado
      if (!window.fbq) {
        !function (f, b, e, v, n, t, s) {
          if (f.fbq) return;
          n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
          };
          if (!f._fbq) f._fbq = n;
          n.push = n;
          n.loaded = true;
          n.version = '2.0';
          n.queue = [];
          t = b.createElement(e);
          t.async = true;
          t.src = v;
          s = b.getElementsByTagName(e)[0];
          if (s && s.parentNode) {
            s.parentNode.insertBefore(t, s);
          } else {
            b.head.appendChild(t);
          }
        }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        window.fbq('init', '1225866266363249');
        window.fbq('track', 'PageView');
      }
      // Evento AddToCart
      if (window.fbq) {
        window.fbq('track', 'AddToCart', {
          value: 17.999,
          currency: 'USD',
          content_name: 'Codigo Sensorial TEA',
          content_type: 'product'
        });
      }
      // Navegar al checkout después de un pequeño delay para asegurar que el pixel se trackee
      setTimeout(() => {
        window.location.href = checkoutUrl;
      }, 100);
    }} className="flex-shrink-0 bg-brand-yellow text-brand-ink font-display font-black uppercase tracking-wider px-8 py-3 rounded-sm whitespace-nowrap text-sm hover:bg-brand-yellow-dark transition-colors" data-id="element-154">
        QUIERO EL MÉTODO →
      </a>
    </div>;
}